// javascript function to convert a string to title case
const toTitleCase = str => {
  return str?.toLowerCase().replace(/\w\S*/g, txt => {
    return txt?.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export default toTitleCase;
